// @flow
import type { ReassignTarget } from 'app/common/components-next/identifiers';
import Identifiers from './Identifiers';


export default Identifiers;

export type { ReassignTarget };
